export default "__VITE_ASSET__DOmG1qk4__"